import { openBlock, createElementBlock, normalizeClass, pushScopeId, popScopeId, createElementVNode } from "vue";
/* empty css                    */
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-chevron-icon",
  props: {
    type: {
      type: String,
      validator(value) {
        return ["right", "default", "down", "left", "up"].includes(value);
      },
      default: "default"
    }
  },
  computed: {
    chevronIconClass() {
      return {
        [`uikit-chevron-icon-${this.type}`]: true
      };
    }
  }
};
const _withScopeId = (n) => (pushScopeId("data-v-bd971ef4"), n = n(), popScopeId(), n);
const _hoisted_1 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("path", {
  d: "M7.93431 0.234315C8.24673 -0.0781049 8.75327 -0.0781049 9.06569 0.234315C9.37811 0.546734 9.37811 1.05327 9.06569 1.36569L5.46569 4.96568C5.15327 5.2781 4.64673 5.2781 4.33431 4.96568L0.734315 1.36569C0.421895 1.05327 0.421895 0.546734 0.734315 0.234315C1.04673 -0.0781049 1.55327 -0.0781049 1.86569 0.234315L4.9 3.26863L7.93431 0.234315Z",
  fill: "currentColor"
}, null, -1));
const _hoisted_2 = [
  _hoisted_1
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    width: "10",
    height: "6",
    viewBox: "0 0 10 6",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: normalizeClass($options.chevronIconClass)
  }, _hoisted_2, 2);
}
const UikitChevronIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-bd971ef4"]]);
export {
  UikitChevronIcon as default
};
//# sourceMappingURL=ChevronIcon.vue.es.js.map
